import { createQueryKeys } from '@lukemorales/query-key-factory';
import {
  BatchDetailResponse,
  EligibleItemsQuery,
  EligibleItemsResponse,
  ItemHistoryResponse,
  ListBatchesQuery,
  ListBatchesResponse,
  settlementCompleteDateAdjustmentApi,
  VerifyResponse,
} from '../../../lib/api/settlementCompleteDateAdjustment';

/**
 * 정산 완료일 변경 도메인의 React Query Key Factory.
 *
 * preview/execute/rollback 은 쓰기/사용자 트리거이므로 mutation 으로 별도 관리하고,
 * 여기서는 list/detail/verify/history 같은 쿼리 키만 정의한다.
 */
export const settlementCompleteDateAdjustmentQuery = createQueryKeys(
  'settlementCompleteDateAdjustment',
  {
    eligibleItems: (params: EligibleItemsQuery) => ({
      queryKey: [params],
      queryFn: (): Promise<EligibleItemsResponse> =>
        settlementCompleteDateAdjustmentApi.getEligibleItems(params),
    }),
    batches: (params: ListBatchesQuery) => ({
      queryKey: [params],
      queryFn: (): Promise<ListBatchesResponse> =>
        settlementCompleteDateAdjustmentApi.listBatches(params),
    }),
    batchDetail: (batchId: string) => ({
      queryKey: [batchId],
      queryFn: (): Promise<BatchDetailResponse> =>
        settlementCompleteDateAdjustmentApi.getBatchDetail(batchId),
    }),
    verify: (batchId: string) => ({
      queryKey: [batchId],
      queryFn: (): Promise<VerifyResponse> =>
        settlementCompleteDateAdjustmentApi.verify(batchId),
    }),
    itemHistory: (settlementItemId: number) => ({
      queryKey: [settlementItemId],
      queryFn: (): Promise<ItemHistoryResponse> =>
        settlementCompleteDateAdjustmentApi.getItemHistory(settlementItemId),
    }),
  },
);
